export default "__VITE_ASSET__B3QYt1Ln__"